<template>
  <div class="devOps_producerSpaceReportWeekly" v-loading="loading">
    <!-- #region 表单搜索部分 -->
    <el-form ref="form" class="form_warp" inline size="mini" :model="form" label-width="100px">
      <el-form-item label="开始日期" prop="startDate" label-width="80px">
        <el-date-picker value-format="yyyy-MM-dd" :style="iptStyle" :clearable = "false" v-model="form.startDate"
                        type="date" placeholder="选择开始日期" />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate" label-width="80px">
        <el-date-picker value-format="yyyy-MM-dd" :style="iptStyle" :clearable = "false" v-model="form.endDate"
                        type="date" placeholder="选择结束日期" />
      </el-form-item>
      <el-form-item>
        <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary"
                    @click.stop="formSearch('reset','search',true)">查询
        </el-button>
        <!-- <el-button  style="margin-left:32px;letter-spacing: 2px;font-weight: bold;font-size: 12px;" type="primary"
                    @click.stop="newApiClick()">切换API
        </el-button> -->
      </el-form-item>
      <div class="time-box">
        <el-button @click="searchTime(1)" size="mini">本周</el-button>
        <el-button @click="searchTime(2)" size="mini">上周</el-button>
        <el-button @click.stop="searchTime(3)" size="mini">过去两周</el-button>
        <el-button @click.stop="searchTime(4)"  size="mini">过去四周</el-button>
        <el-button @click.stop="searchTime(5)" size="mini">本月</el-button>
      </div>
    </el-form>
    <!-- #endregion 表单搜索部分 -->
    <!-- #region 表格部分 -->
    <div style="height: 65vh;position: relative;">
      <div class="show-box">
        <div class="show-color">
          <template v-for="(item,index) in showColormsg">
            <span v-if="index === 0">
            <span style="background: red; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>{{item.red}}
            <span style="background: #ffc000; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>{{item.yellow}}
            <span style="background: lightgray; padding: 0px; ">&nbsp;&nbsp;&nbsp;&nbsp;</span>{{item.grep}}
              </span>
          </template>
<!--          <span style="background: red; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>负荷及人效:[0%,30%);平均工时:(15,+∞]-->
<!--          <span style="background: yellow; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>负荷及人效:[30%,50%];平均工时:[10,15]-->
<!--          <span style="background: lightgray; padding: 0px; ">&nbsp;&nbsp;&nbsp;&nbsp;</span>暂不做要求-->
          <!--
          <span style="background: green; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>已完成
          <span style="background: cornflowerblue; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>进行中
          <span style="background: yellowgreen; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>待开始
          <span style="background: gray; padding: 0px; ">&nbsp;&nbsp;&nbsp;&nbsp;</span>非工作日
          <span style="background: white; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>空余
          <span style="background: red; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>逾期
          <span style="background: lightpink; padding: 0px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>逾期风险-->
        </div>
      </div>

      <el-table height="100%" :header-cell-style="getCellClass"  row-key="id" ref="multipleTable"
                :expand-row-keys="expands" @row-click="clickRowHandle" style="margin-top:0;" :cell-style="getRowClass"
                @sort-change="sortChange" :data="tableData" :span-method="objectSpanMethod">
        <el-table-column prop="project" label="项目" :show-overflow-tooltip="true" min-width="100">
          <template slot-scope="scope">
            <el-popover placement="top-start" trigger="hover">
              <div v-for="(item,index) in showColormsg">
            <div v-if="item.project === scope.row.project">
            <div style="display: flex;margin: 10px;"><div style="background: red; padding: 0px;width:20px;">&nbsp;&nbsp;&nbsp;&nbsp;</div>{{item.red}}</div>
              <div style="display: flex;margin:10px;"><div style="background: #ffc000;  padding: 0px;width:20px;">&nbsp;&nbsp;&nbsp;&nbsp;</div>{{item.yellow}}</div>
              <div style="display: flex;margin: 10px;"><div style="background: lightgray; padding: 0px;width:20px;">&nbsp;&nbsp;&nbsp;&nbsp;</div>{{item.grep}}</div>
              </div>
              </div>
              <span  slot="reference">{{scope.row.project}}</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column  prop="department" align="center" width="140" label="职能" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="num_renyuan" label="人数" :show-overflow-tooltip="true" width="100">
        </el-table-column>
        <!-- <el-table-column prop="fhf" align="center" width="110" label="负荷(平均)" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{scope.row.fhf}}/{{scope.row.fhm}}
          </template>
        </el-table-column> -->
        <el-table-column  prop="undo_date_hour" align="center" width="140" label="未完成工时(平均)" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="renxiao" align="center" width="130" label="人效(平均)" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.renxiao}}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="bzrurx" align="center" width="180" label="标准任务人效(平均)" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{scope.row.bzrurx}}%</span>
          </template>
        </el-table-column>
        <el-table-column prop="wcrwpjgs" align="center" width="200" label="完成任务平均工时(平均)" :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
    </div>
    <!-- #endregion 表格部分 -->
  </div>
</template>
<script>
import {
  getDevOpsSpaceProducerListApi,
  getDevOpsSpaceNewReviewListApi,
  getDevOpsSpacePerformanceDetailListApi,
  getDevOpsSpacePerformanceListApi,
  getDevOpsSpaceTeamListApi, getDevOpsSpaceWeeeklyReportApi, getDevOpsSpaceWeeeklysReportApi
} from "@/server/tops/devOps";
import { formatEnToUtf8, formatTimeToDate, formatEnToUtf8NoEn } from "@/views/tops/devOps/components/util.js";
import { getStorage, setStorage } from "@/common/utils/storage.js"
import { mapState, mapMutations } from 'vuex';
import {getDevOpsSpaceAllUserListApi, getDevOpsSpaceSystemApi} from "@/server/tops/base";
import moment from "moment";
export default {

  components: {},
  props: {
    tabid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableData:[
      ],
      // 表单搜索条件
      form: {
        startDate: '',
        endDate: '',
      },
      // input 搜索样式
      iptStyle: {
        width: '180px'
      },
      isNewApi:true,
      loading:false,
      showColormsg:[],
    };
  },
  async created() {
  },
  computed: {
    ...mapState(
        {
        }
    ),

  },
  watch: {
    'tableData': {
      handler() {
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout()
        })
      },
      deep: true
    }
  },
  async mounted() {
    let nowday = new Date().getDay();
    let day = nowday || 7;
    this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1));
    this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1) + 60 * 60 * 24 * 1000 * 6);
    this.$nextTick(async () => {
      await this.formSearch();
    })
  },
  methods: {
    ...mapMutations(['filterSelect']),
    getCellClass(row, column, rowIndex, columnIndex) {
      return "padding: 4px 0;height:36px;background:#7F7F7F;color:#FFFFFF;font-size:14px;"
    },
    // 扩展行
    clickRowHandle(row, column, event) { },
    // 表格样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if(columnIndex == 0){
        return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;font-weight: bold;padding:8px 0;border-right:1px solid #EBEEF5;";
      }
      // if(columnIndex == 3 && row.fhf_fhm_color){
      //   return `border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:8px 0;background-color:${row.fhf_fhm_color};color:#fff`;
      // }
      if(columnIndex == 4 && row.renxiao_color){
        return `border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:8px 0;background-color:${row.renxiao_color};color:#fff`;
      }
      if(columnIndex == 5 && row.bzrurx_color){
        return `border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:8px 0;background-color:${row.bzrurx_color};color:#fff`;
      }
      if(columnIndex == 6 && row.wcrwpjgs_color){
        return `border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:8px 0;background-color:${row.wcrwpjgs_color};color:#fff`;
      }
      return "border:none;border-top:1px solid #EBEEF5;font-size: 12px;padding:8px 0;";
    },
    // 表单搜索
    async formSearch(type,key) {
      if((this.form.startDate && !this.form.endDate) || (!this.form.startDate && this.form.endDate)){
        this.$notify({
          message: "请选择日期",
          type: "error",
        })
        return false;
      }
      if(this.form.startDate && this.form.endDate){
        if(this.form.startDate > this.form.endDate){
          this.$notify({
            message: "结束日期必须大于开始日期",
            type: "error",
          })
          return false;
        }
      }
      this.tableData = [];
      this.loading = true;
      try {
        let params = {};
        for (const key in this.form) {
          const val = this.form[key];
          params[key] = this.$SELFTYPEJUDGE.isArray(val) ? val.toString() : val;
        }
        let ret = this.isNewApi ? await getDevOpsSpaceWeeeklysReportApi(params) : await getDevOpsSpaceWeeeklyReportApi(params);
        if(this.isNewApi){
          this.tableData = this.newFormatTableData(ret);
        }else{
          this.tableData = this.formatTableData(ret.data);
        }



        this.loading = false;
      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
        this.loading = false;
      } finally {
        this.loading = false;
      }
      return false;
    },
    newFormatTableData(ret){
    /*  let arr = Object.keys(ret.data);
      let  projectAll = arr.reduce((result, item) => {
        result[item] = [];
        return result;
      }, []);*/
      let projectAll = [];
      Object.keys(ret.data).forEach((item)=>{
        let newArr = [];
        Object.keys(ret.data[item]).forEach((item2)=>{
          let isAdd = false;
          if(ret.data[item][item2].num || ret.data[item][item2].data.bzrurx ||  ret.data[item][item2].data.renxiao || ret.data[item][item2].data.wcrwpjgs){
            isAdd = true;
          }
          if(isAdd){
            newArr.push({...ret.data[item][item2].data,project:item,department:item2,num_renyuan:ret.data[item][item2].num});
          }
        })
        projectAll.push({'projectList':newArr,project:item});
       /* projectAll[item].projectList = newArr;
        projectAll[item].project = item;*/
      });
      const lists = this.formatTableData(projectAll);
      //处理显示信息
      if(ret.message){
        this.handleMessage(ret.message);
      }
      return lists;
    },
    // 格式化数据
    formatTableData(data) {
      let newData = [];
      if(this.isNewApi){
         newData = data;
      }else{
        newData = this.handleData(data, 'project');
      }

      let List = []
      newData.forEach(item => {
        item.projectList.forEach((obj, index) => {
          //存在子集的行，开始平铺数据和塞入合并标识

          if (index == 0) {
            //子集平铺，第一条就是开始行列合并的行
            List.push({
              project: obj.project,
              bzrurx: obj.bzrurx.toFixed(2),
              bzrurx_color: obj.bzrurx_color === 'yellow'?'#ffc000':obj.bzrurx_color,
              department: obj.department,
              fhf: obj.fhf.toFixed(),
              fhf_fhm_color: obj.fhf_fhm_color === 'yellow'?'#ffc000':obj.fhf_fhm_color,
              fhm: obj.fhm.toFixed(),
              num_renyuan: obj.num_renyuan,
              renwugeshu: obj.renwugeshu,
              renxiao: obj.renxiao.toFixed(2),
              renxiao_color: obj.renxiao_color === 'yellow'?'#ffc000':obj.renxiao_color,
              wcrwpjgs: obj.wcrwpjgs.toFixed(2),
              undo_date_hour: obj.undo_date_hour,
              wcrwpjgs_color: obj.wcrwpjgs_color === 'yellow'?'#ffc000':obj.wcrwpjgs_color,
              yanqirenwushu:obj.yanqirenwushu,
              rowspan: item.projectList.length, //关键，塞入合并标识和合并的行数
            })
          } else {
            //子集的其他行，同样平铺数据
            List.push({
              project: obj.project,
              bzrurx: obj.bzrurx.toFixed(2),
              bzrurx_color: obj.bzrurx_color === 'yellow'?'#ffc000':obj.bzrurx_color,
              department: obj.department,
              fhf: obj.fhf.toFixed(),
              fhf_fhm_color: obj.fhf_fhm_color === 'yellow'?'#ffc000':obj.fhf_fhm_color,
              fhm: obj.fhm.toFixed(),
              num_renyuan: obj.num_renyuan,
              renwugeshu: obj.renwugeshu,
              renxiao: obj.renxiao.toFixed(2),
              renxiao_color: obj.renxiao_color === 'yellow'?'#ffc000':obj.renxiao_color,
              wcrwpjgs: obj.wcrwpjgs.toFixed(2),
              undo_date_hour: obj.undo_date_hour,
              wcrwpjgs_color: obj.wcrwpjgs_color === 'yellow'?'#ffc000':obj.wcrwpjgs_color,
              yanqirenwushu:obj.yanqirenwushu,
            })
          }
        })
      })
     return List;
    },
    /**
     *
     * @param list 待处理列表
     * @param key  分组字段
     * @returns {{[p: string]: *, list: *}[]}
     */
    handleData(list,key){
      //得到数据的主键列表
      let keysArr = list.map(item=>item[key])
      let keys = [...new Set(keysArr)]
      let newList = keys.map(item=>{
        return {
          [key]:item,
          projectList:list.filter(i=>i[key]==item)
        }
      })
      return newList;
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        //第一列
        if (row.rowspan&&row.rowspan >= 1) {
          //行属性中rowspan存在，并且大于等于1的，开始合并
          return {
            rowspan: row.rowspan, //合并的行数
            colspan: 1 //合并的列数
          };
        } else {
          //不合并，以下写法等于不操作任何
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    changeTimeDate(timestamp){
      let dateObj = new Date(timestamp);
      // 提取所需的年、月、日等信息
      let year = dateObj.getFullYear();
      let month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      let day = dateObj.getDate().toString().padStart(2, '0');
      // 构造最终的日期/时间字符串
      let formattedTime = `${year}-${month}-${day}`;
      return formattedTime;
    },
    searchTime(type){
      let nowday = new Date().getDay();
      let day = nowday || 7;
      if(type === 1){
        //本周
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1));
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1) + 60 * 60 * 24 * 1000 * 6);
      }
      if(type === 2){
        //上周
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1) - 60 * 60 * 24 * 1000 * 7);
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1) - 60 * 60 * 24 * 1000 );
      }
      if(type === 3){
        //过去两周
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1) - 60 * 60 * 24 * 1000 * 14);
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1) + 60 * 60 * 24 * 1000 * 6);
      }

      if(type === 4){
        //过去四周
        this.form.startDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1) - 60 * 60 * 24 * 1000 * 28);
        this.form.endDate = this.changeTimeDate(new Date(this.$moment(new Date()).format("YYYY-MM-DD 00:00:00")).getTime() - 60 * 60 * 24 * 1000 * (day - 1) + 60 * 60 * 24 * 1000 * 6);
      }

      if(type === 5){
        //本月
        this.form.startDate = moment().startOf('months').format('YYYY-MM-DD');
        this.form.endDate = moment().format('YYYY-MM-DD');
      }

      this.formSearch();
    },
    // newApiClick(){
    //   this.tableData = [];
    //   this.isNewApi = !this.isNewApi;
    //   this.formSearch('reset','search')
    // },
    handleMessage(msg){
      let arr = [];
      Object.keys(msg).forEach((item)=>{
        let red = '人效:'+msg[item]['now_load_front3_red']+';平均工时:'+msg[item]['workhours_4_red'];
        let yellow = '人效:'+msg[item]['now_load_front3_yellow']+';平均工时:'+msg[item]['workhours_4_yellow'];
        arr.push({project:item,red:red,yellow:yellow,grep:'暂不做要求'});
      })
      this.showColormsg = arr;
    },
    // 将英文名字转为中卫
    formatEnToUtf8,
    formatEnToUtf8NoEn,
    // 毫秒值转 YYYY-MM-DD HH:mm:ss
    formatTimeToDate
  },
};
</script>
<style lang="scss">
.devOps_producerSpaceReportWeekly {

  .form_warp .el-form-item {
    margin-bottom: 6px;
  }

  padding-top: 10px;


  .el-form-item__label {
    font-weight: bold;
  }

  .show-box{
    float: right;
    margin-right:10px;
  }
  .show-color{
    font-size: 12px;
    padding: 10px 20px;
    background: #eee;
    width: 560px;
    text-align: center;
    margin-bottom: 10px;
  }

}

/* #region 滚动条部分 */
.el-table__body-wrapper {
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.el-table__body-wrapper::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

.tips-message {
  max-height: 480px;
  overflow-y: auto;
  white-space: pre-wrap;
  background: #f1fbec;
  scrollbar-width: thin;
  scrollbar-color: skyblue #eee;
}

.websocket_style {
  background-color: #333;
  color: #fefefe;
  padding: 8px;

  a {
    color: #e6a23c;
  }
}

.tips-message::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 16px;
}

.tips-message::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-color: skyblue;
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent);
}

.tips-message::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ededed;
  border-radius: 10px;
}

/* #endregion 滚动条部分 */

.devOps_producerSpaceReportWeekly .el-form-item__label {
  font-weight: bold;
  font-size: 12px;
}

.devOps_producerSpaceReportWeekly .time-box{
  margin-bottom: 15px;
  margin-left: 15px;
}


</style>
